import styled from 'styled-components';

import { useSortable } from '@dnd-kit/react/sortable';

import DragHandle from 'components/shared/DragHandle';
import Launcher from 'components/shared/Launcher';
import { colors } from 'styles/theme/colors';

import type { CriteriaCategory } from './NewCategoryModal';

type Props = {
  category: CriteriaCategory;
  index: number;
  criteriaCount: number;
  onClick: () => void;
};

export default function CategoryCard({ category, index, criteriaCount, onClick }: Props) {
  const { ref, handleRef, isDragSource } = useSortable({
    id: category._tempId,
    index,
  });

  const subLabel = `${criteriaCount} Criteria`;

  return (
    <CardRow ref={ref} style={{ opacity: isDragSource ? 0.5 : 1 }}>
      <DragHandle ref={handleRef} />
      <LauncherWrapper>
        <Launcher label={category.name} subLabel={subLabel} handleLaunch={onClick} />
      </LauncherWrapper>
    </CardRow>
  );
}

type InheritedProps = {
  category: CriteriaCategory;
  criteriaCount: number;
  onClick: () => void;
};

/**
 * Read-only card for a category inherited from the client-level criteria set.
 * Unlike `CategoryCard`, this is not part of the draggable/sortable list --
 * it has no drag handle and can't be reordered, edited, or deleted from here.
 */
export function InheritedCategoryCard({ category, criteriaCount, onClick }: InheritedProps) {
  const subLabel = `${criteriaCount} Criteria`;

  return (
    <CardRow>
      <LauncherWrapper>
        <Launcher
          label={category.name}
          subLabel={subLabel}
          handleLaunch={onClick}
          showPill
          pillText='Inherited'
          pillColors={{ color: colors.black75, borderColor: colors.black25, backgroundColor: colors.black5 }}
        />
      </LauncherWrapper>
    </CardRow>
  );
}

const CardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LauncherWrapper = styled.div`
  flex: 1;
`;
